import React, { memo, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import CommonPopper from '../../../components/common-popper/CommonPopper';
import UserMenu from '../user-menu/UserMenu';
import UserAvatar from './UserAvatar';
import ChangeUserPasswordModal from '../../../user-management/change-password-modal/ChangeUserPasswordModal';
import useFormattedName from '../../../hooks/useFormattedName';

import scss from './UserProfile.module.scss';

const UserProfile = () => {
  const currentUserInfo = useSelector((state) => state.securityNew.currentUserInfo);
  const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] = useState(false);

  const formattedName = useFormattedName();

  const handleOpenChangePasswordModal = useCallback(() => {
    setIsChangePasswordModalOpen(true);
  }, []);

  const handleCloseChangePasswordModal = useCallback(() => {
    setIsChangePasswordModalOpen(false);
  }, []);

  return (
    <div className={scss.userProfile}>
      <div className={scss.userName}>{formattedName}</div>

      <CommonPopper
        placement='bottom-end'
        component={(props) => (
          <UserMenu
            {...props}
            username={currentUserInfo.username}
            onChangePassword={handleOpenChangePasswordModal}
            formattedName={formattedName}
          />
        )}>
        <UserAvatar name={formattedName} />
      </CommonPopper>

      <ChangeUserPasswordModal
        isOpen={isChangePasswordModalOpen}
        username={currentUserInfo.username}
        onClose={handleCloseChangePasswordModal}
      />
    </div>
  );
};

export default memo(UserProfile);
